import React from "react";
import { IconFood, Paragraph } from "@trainline/depot-web";
import * as s from "./OnboardServicesFooter.module.css";
import TransitLegFooter from "./TransitLegFooter";
const OnboardServicesFooter = ({ onboardServices }) => {
  const onboardServicesList = /* @__PURE__ */ React.createElement(Paragraph, {
    typeStyle: "mini",
    color: "subtle",
    className: s.onboardServicesList
  }, onboardServices.join(" \u2022 "));
  return /* @__PURE__ */ React.createElement(TransitLegFooter, {
    labelMessage: "transitLeg.onboardServices",
    icon: /* @__PURE__ */ React.createElement(IconFood, {
      className: s.icon
    }),
    content: onboardServicesList
  });
};
var OnboardServicesFooter_default = OnboardServicesFooter;
export {
  OnboardServicesFooter_default as default
};
